import React from 'react';
import PropTypes from 'prop-types';
import Markdown from 'react-markdown';

import Hero from '../Hero';
import About from '../About';
import Engineering from '../Engineering';
import Navbar from '../Navbar';
import Footer from '../Footer';
import Logo from '../Logo';
import Sponsors from '../Sponsors';
import Schedule from '../Schedule';
import Faqs from '../Faqs';
import LogIn from '../LogIn';

import './fullindex.scss';
import Judges from '../Judges';

class IndexPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      showingLogInModal: false,
    };

    this.logInModal = React.createRef();
  }

  componentDidMount() {
    setTimeout(() => {
      if (!this.checkAndRedirectPasswordResetModal()) {
        this.setState({ loaded: true, showingLogInModal: window.location.hash === '#signin' });
      } else {
        this.setState({ loaded: true });
      }
    }, 500);
  }

  resetModalAndToggle = () => {
    this.logInModal.current.goToLogIn();
    this.toggleLogInModal();
  }

  toggleLogInModal = () => {
    this.setState({ showingLogInModal: !this.state.showingLogInModal });
  }

  checkAndRedirectPasswordResetModal = () => {
    const url = new URL(window.location.href);

    const token = url.searchParams.get('token');
    const email = url.searchParams.get('email');

    if (token && email) {
      this.toggleLogInModal();
      return true;
    }

    return false;
  }

  render() {
    const { loaded } = this.state;
    return (
      <React.Fragment>
        { loaded ? null : <div className="loading-spinner"><Logo color="#88C2E5" /></div>}
        <section className="full-index" style={!loaded ? {} : { opacity: 1 }}>
          <Navbar loaded={loaded} toggleLogInModal={this.resetModalAndToggle} />
          <Hero data={this.props.hero} />
          <About>
            <Markdown>{this.props.about}</Markdown>
          </About>
          <Engineering>
            <Markdown>{this.props.engineering}</Markdown>
          </Engineering>
          <Judges data={this.props.judges} />
          <Sponsors data={this.props.sponsors} />
          <Schedule />
          <Faqs data={this.props.faq} />
          <Footer />
          {
            !this.props.disableLogin && <LogIn
              ref={this.logInModal}
              show={this.state.showingLogInModal}
              toggle={this.toggleLogInModal}
            />
          }
        </section>
      </React.Fragment>
    );
  }
}

IndexPage.propTypes = {
  hero: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  about: PropTypes.string.isRequired,
  engineering: PropTypes.string.isRequired,
  sponsors: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  faq: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  disableLogin: PropTypes.bool.isRequired,
  judges: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

export default IndexPage;



// WEBPACK FOOTER //
// ./src/components/FullIndex/index.jsx